import { Container, Row } from "react-bootstrap";
import Section from "../UI/Section.jsx";
import styled from "styled-components";
import GBLogoBlack from "images/landing/Header/GBLogoBlack2.svg";
import { H500, T300 } from "../Styles.js";
import Button from "../UI/Button.js";
import I18n from "i18n-js";

type EnrollmentSuccessProps = {
  hotelName: string;
  hotelUrl: string;
}

const EnrollmentSuccessWrapper = styled.div`
  height: 100vh; 
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) => theme.tablet`
     padding: 32px;
  `}
`;

const EnrollmentSuccessContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  width: 434px;
  background: #FFF;
  text-align: center;
  align-items: center;  
  border-radius: 24px;
`;

const LogoContainer = styled.div`
  height: 70px;
  width: 70px;
  margin-bottom: 24px;
`;

const StyledLogoImg = styled.img`
  width: 100%;
`;

const SuccessHeader = styled(H500)`
  font-family: Sentient;
  margin-bottom: 16px;
`;

const SuccessDetails = styled.div`
  display: flex; 
  flex-direction: column;
  gap: 8px;
  margin-bottom: 32px;
`;

const HotelLink = styled.a`
  width: 100%;
`;

const EnrollmentSuccess = ({
  hotelName,
  hotelUrl
}: EnrollmentSuccessProps) => {
  return (
    // TODO: replace with real image
    <Row>
      <Section
        backgroundType="image"
        backgroundData={"https://theguestbook.s3.us-east-1.amazonaws.com/public/hotel_landing_enroll_success.jpg"}
        isHeroImage={false}
        isHotelLanding={true}
      >
        <EnrollmentSuccessWrapper>
          <EnrollmentSuccessContent>
            <LogoContainer>
              <StyledLogoImg src={GBLogoBlack} alt="The Guestbook Logo" />
            </LogoContainer>
            <SuccessHeader>
              {I18n.t("views.static_pages.hotel_landing.enrollment_success.header")}
            </SuccessHeader>
            <SuccessDetails>
              <T300>
                {I18n.t("views.static_pages.hotel_landing.enrollment_success.details.text_1")}
              </T300>
              <T300>
                {I18n.t("views.static_pages.hotel_landing.enrollment_success.details.text_2", {
                  hotel_name: hotelName
                })}
              </T300>
            </SuccessDetails>
            <HotelLink href={hotelUrl}>
              <Button
                kind="primary"
              >
                {I18n.t("views.static_pages.hotel_landing.enrollment_success.button_text")}
              </Button>
            </HotelLink>
          </EnrollmentSuccessContent>
        </EnrollmentSuccessWrapper>
      </Section>
    </Row>
  )
}

export default EnrollmentSuccess;
